<template>
    <div class="home my-5">
        <!--USERS TABLE-->
        <b-table
                striped
                :items="items"
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                class="custom table-users"
                :tbody-tr-class="rowClass"
        >
            <template slot="top-row" :columns="fields.length" slot-scope="data" :class="'sub-header'">
                <td :key="key" v-for="(field, key) in fields">
                    <template v-if="key === 4">

                        <b-dropdown id="dropdown-1" text="" size="sm"
                                    variant="defoult" class="custom t-btn ">
                            <b-dropdown-item>First Action</b-dropdown-item>
                            <b-dropdown-item>Second Action</b-dropdown-item>
                            <b-dropdown-item>Third Action</b-dropdown-item>
                        </b-dropdown>

                    </template>
                    <template v-else-if="key === 5"/>
                    <template v-else class="qwe">
                        <div class="d-flex">

                            <!-- <b-form-input class="custom sm search"></b-form-input>-->
                            <div class="input-group sm custom search ">

                                <input type="text"
                                       class="form-control sm custom"
                                       placeholder=""
                                       aria-describedby="basic-addon1">
                                <div class="input-group-prepend">
                                    <a href="#">
                                        <span class="input-group-text icon-search icon px-0"></span>
                                    </a>
                                </div>
                            </div>
                            <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none">
                                <template slot="button-content"><span class="sr-only custom">Search</span></template>
                                <b-dropdown-item href="#">Action</b-dropdown-item>
                                <b-dropdown-item href="#">Another action</b-dropdown-item>
                                <b-dropdown-item href="#">Something else here...</b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </template>
                </td>
            </template>

            <template slot="status" slot-scope="scope">
                <p class="border-status custom " :class="scope.item.status ? 'border-success' : 'border-danger'">
                    {{scope.item.status}}</p>
            </template>

            <template slot="actions" slot-scope="scope">
                <div class="wrap-ico-btn d-flex justify-content-between">
                    <a href="" class="#">
                        <span class="icon icon-open"></span>
                    </a>
                    <a href="" class="#">
                        <span class="icon icon-edit"></span>
                    </a>
                    <a href="" class="#">
                        <span class="icon icon-delete"></span>
                    </a>
                </div>
            </template>
        </b-table>
        <b-row>

            <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    class=" custom"
            ></b-pagination>

        </b-row>
        <!--USERS TABLE-->

        <!--GRAPHIC TABLE-->
        <!--<b-table
                striped
                :items="items2"
                :fields="fields2"
                :per-page="perPage2"
                :current-page="currentPage2"
                responsive="sm"
        >
            <template slot="HEAD_name" slot-scope="data">
                <em>{{ data.label }}</em>
            </template>
        </b-table>

        <b-row>
                <b-pagination
                        v-model="currentPage2"
                        :total-rows="totalRows2"
                        :per-page="perPage2"
                        class="custom"
                ></b-pagination>
        </b-row>-->
        <!--GRAPHIC TABLE-->

    </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  },
  data () {
    return {
      currentPage: 1,
      currentPage2: 1,
      totalRows: 1,
      totalRows2: 1,
      perPage: 3,
      perPage2: 3,
      items: [
        {
          fullname: 'Stephen Hawking',
          firmName: 1,
          outpostAddress: false,
          role: true,
          status: true,
          type2c: false,
          type3: false
        },
        {
          fullname: 'Johnny Appleseed',
          firmName: 2,
          outpostAddress: false,
          role: true,
          status: true,
          type2c: false,
          type3: false
        },
        {
          fullname: 'George Washington',
          firmName: 3,
          outpostAddress: false,
          role: false,
          status: false,
          type2c: false,
          type3: true
        },
        {
          fullname: 'Albert Einstein',
          firmName: 4,
          outpostAddress: true,
          role: false,
          status: false,
          type2c: true,
          type3: false
        },
        {
          fullname: 'Isaac Newton',
          firmName: 5,
          outpostAddress: true,
          role: true,
          status: false,
          type2c: true,
          type3: false
        }
      ],
      fields: [
        // 'name',
        { key: 'fullname', label: 'Imię i nazwisko', sortable: true },
        { key: 'firmName', label: 'Nazwa firmy', sortable: true },
        { key: 'outpostAddress', label: 'Adres placówki', sortable: true },
        { key: 'role', label: 'Rola', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'actions', label: 'Operacje' },
        { key: 'functions', label: 'Funkcje' }
      ],
      items2: [
        {
          date: 'Stephen Hawking',
          result: 1
        },
        {
          date: 'Stephen Hawking',
          result: 1
        },
        {
          date: 'Stephen Hawking',
          result: 1
        },
        {
          date: 'Stephen Hawking',
          result: 1
        },
        {
          date: 'Stephen Hawking',
          result: 1
        },
        {
          date: 'Stephen Hawking',
          result: 1
        }
      ],
      fields2: [
        { key: 'date', label: '' },
        { key: 'result', label: '' }
      ]
    }
  },
  methods: {
    rowClass (item, type) {
      if (type === 'row-top') {
        return 'sub-header'
      }
      return ''
    }
  },
  mounted () {
    // Set the initial number of items
    this.totalRows = this.items.length

    let testJson = {
      'missingKeys': [
        {
          'path': 'zabłokuj',
          'line': 3,
          'file': 'C:/wamp64/www/toilets/front/src/components/Buttons/BlockButton/index.vue',
          'language': 'pl'
        },
        {
          'path': 'usuń',
          'line': 3,
          'file': 'C:/wamp64/www/toilets/front/src/components/Buttons/DeleteButton/index.vue',
          'language': 'pl'
        },
        {
          'path': 'edytuj',
          'line': 5,
          'file': 'C:/wamp64/www/toilets/front/src/components/Buttons/EditButton/index.vue',
          'language': 'pl'
        },
        {
          'path': 'podgląd',
          'line': 5,
          'file': 'C:/wamp64/www/toilets/front/src/components/Buttons/PreviewButton/index.vue',
          'language': 'pl'
        },
        {
          'path': 'Częstotliwości sprzątania',
          'line': 6,
          'file': 'C:/wamp64/www/toilets/front/src/views/Administration/CleaningFrequencies/CleaningFrequencies.vue',
          'language': 'pl'
        },
        {
          'path': 'Dodaj częstotliwość',
          'line': 11,
          'file': 'C:/wamp64/www/toilets/front/src/views/Administration/CleaningFrequencies/CleaningFrequencies.vue',
          'language': 'pl'
        },
        {
          'path': 'Wyszukaj',
          'line': 34,
          'file': 'C:/wamp64/www/toilets/front/src/views/Administration/CleaningFrequencies/CleaningFrequencies.vue',
          'language': 'pl'
        },
        {
          'path': 'Dane częstotliwości',
          'line': 13,
          'file': 'C:/wamp64/www/toilets/front/src/views/Administration/CleaningFrequencies/CleaningFrequency.vue',
          'language': 'pl'
        },
        {
          'path': 'Tytuł',
          'line': 18,
          'file': 'C:/wamp64/www/toilets/front/src/views/Administration/CleaningFrequencies/CleaningFrequency.vue',
          'language': 'pl'
        },
        {
          'path': 'Companies',
          'line': 4,
          'file': 'C:/wamp64/www/toilets/front/src/views/Companies/Companies.vue',
          'language': 'pl'
        },
        {
          'path': 'Dodaj Firmę',
          'line': 5,
          'file': 'C:/wamp64/www/toilets/front/src/views/Companies/Companies.vue',
          'language': 'pl'
        }
      ],
      'unusedKeys': []
    }
    let str = 'INSERT INTO `translation_key` (`title`, `isAdmin`, `id`, `created`, `updated`) VALUES'

    for (let i = 0; i < testJson['missingKeys'].length; i++) {
      str = str + "('" + testJson['missingKeys'][i].path + "', '0', NULL, '2019-07-12 00:00:00', '2019-07-12 00:00:00'),"
    }
    console.log(str)
  }
}
</script>
